import RejectButton from 'domain/finance/shared/button/RejectButton';
import { REJECT_WASTE, useWasteService, WASTE_STATUSES } from 'domain/shared/waste';
import { useWasteId } from '../useWasteId';
import { useFieldHelper } from 'framework/ui/field';

const RejectWasteButton = ({ statusSource }: { statusSource: string }) => {
  const id = useWasteId();
  const { rejectWaste } = useWasteService();
  const { getValue } = useFieldHelper({ source: statusSource });
  const status = getValue();

  if (status !== WASTE_STATUSES.REGISTERED) {
    return null;
  }

  return (
    <RejectButton
      displayMessage="Do you really want to reject Waste?"
      deleteMethod={rejectReason => rejectWaste(id, rejectReason)}
      successMessage="The Waste has been successfully rejected."
      errorMessage="Can't reject Waste."
      permissionToCheck={REJECT_WASTE}
    />
  );
};

export default RejectWasteButton;
